import { prompt, type PromptDefinition } from './models';

export const REAL_ESTATE_DEVELOPER_PROMPTS = [
    prompt(
        'Plan change',
        'What approvals are documented for proposed development of this building?',
        'Which buildings have development proposals with outstanding approval evidence?'
    ),
    prompt(
        'Plan change',
        'What site or planning constraints are documented for this building?',
        'Compare documented site and planning constraints across my buildings.'
    ),
    prompt(
        'Plan change',
        "What due-diligence reports are missing for this building's proposed development?",
        'Which buildings have the largest development due-diligence gaps?'
    ),
    prompt(
        'Plan change',
        'Find development feasibility records for this building about…',
        'Find development feasibility records across my buildings about…',
        'prefill'
    ),
    prompt(
        'Plan change',
        "What conditions in this building's planning approvals need follow-up?",
        'Which buildings have planning conditions to address before development proceeds?'
    ),
    prompt(
        'Plan change',
        'What do available reports say about infrastructure capacity for this building?',
        'Which buildings have infrastructure-capacity constraints requiring investigation?'
    ),
    prompt(
        'Plan change',
        "Which dependencies are documented in this building's development programme?",
        'Which buildings have development dependencies that could delay milestones?'
    ),
    prompt(
        'Plan change',
        'Find planning correspondence for this building concerning…',
        'Find planning correspondence across my buildings concerning…',
        'prefill'
    ),
    prompt(
        'Plan change',
        "What cost assumptions are recorded in this building's feasibility documents?",
        'Compare documented feasibility assumptions across my buildings.'
    ),
    prompt(
        'Manage risk',
        'What environmental or contamination findings affect development of this building?',
        'Which buildings have environmental findings affecting development readiness?'
    ),
    prompt(
        'Plan change',
        "What is still unresolved in this building's development handover requirements?",
        'Which buildings have development handover requirements without completion evidence?'
    ),
    prompt(
        'Plan change',
        'Summarise development options for this building based on…',
        'Compare development options across my buildings based on…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
